import LogoVip from '../../src/legacy/LogoVip';
export default LogoVip;
